module.exports = __webpack_public_path__ + "static/media/888-gold.4f11ed13.gif";